import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Typography, CircularProgress, Button } from '@mui/material';
import CommonTable from '../../Shared/Tables/TableV1.tsx';
import { HomeActions } from '../../../Services/_actions/home.action.js';

const ProposalSummary = () => {
  const { id } = useParams();
  const [proposalData, setProposalData] = useState<any>(null);
  const [shortlistedSuppliers, setShortlistedSuppliers] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const actions = HomeActions();
  const navigate = useNavigate();

  const fetchProposalData = async () => {
    try {
      const res = await actions.getProposalById(id);
      setProposalData(res?.data);

      const supplierRes = await actions.getShortlistedSuppliers(id);
      const suppliersData = supplierRes?.data || {};

      const processedSuppliers = Object.values(suppliersData).map((center: any) => ({
        center_name: center.center.center_name,
        area: center.center.area,
        subarea: center.center.subarea,
        radius: center.center.radius,
        city: center.center.city,
        pincode: center.center.pincode,
        codes: center.center.codes.join(', '),
        supplier_count: Object.values(center.suppliers).reduce(
          (acc: number, suppliers: any[]) => acc + suppliers.length,
          0
        ),
      }));

      setShortlistedSuppliers(processedSuppliers);
    } catch (error) {
      console.error('Failed to fetch proposal data or shortlisted suppliers:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchProposalData();
  }, [id]);

  const handleViewMap = () => {
    // navigate('/r/leads/map-view', { state: { proposal_id: id } });
      navigate('/r/records/map-view', { state: { proposal_id: id } });
  };

  const proposalInfoColumns = [
    { accessorKey: 'proposal_id', header: 'Proposal Id' },
    { accessorKey: 'name', header: 'Name of Proposal' },
    { accessorKey: 'tentative_cost', header: 'Tentative Cost' },
  ];

  const proposalInfoData = proposalData
    ? [
        {
          proposal_id: proposalData.proposal_id,
          name: proposalData.name,
          tentative_cost: `₹${proposalData.tentative_cost?.toLocaleString('en-IN')}`,
        },
      ]
    : [];

  const locationColumns = [
    { accessorKey: 'center_name', header: 'Center Name' },
    { accessorKey: 'area', header: 'Area' },
    { accessorKey: 'subarea', header: 'SubArea' },
    { accessorKey: 'radius', header: 'Radius' },
    { accessorKey: 'supplier_count', header: 'Supplier Count' },
  ];

  const shortlistedColumns = [
    { accessorKey: 'center_name', header: 'Center Name' },
    { accessorKey: 'area', header: 'Area' },
    { accessorKey: 'subarea', header: 'SubArea' },
    { accessorKey: 'radius', header: 'Radius' },
    { accessorKey: 'city', header: 'City' },
    { accessorKey: 'pincode', header: 'Pincode' },
    // { accessorKey: 'codes', header: 'Category Codes' },
    { accessorKey: 'supplier_count', header: 'Total Suppliers' },
  ];

  return (
    <Box p={2}>
      <Typography variant="h5" mb={3}>
        Proposal Summary
      </Typography>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
          <CircularProgress />
        </Box>
      ) : proposalData ? (
        <>
          <Typography variant="h6" mb={2}>
            Proposal Information
          </Typography>
          <CommonTable
            columns={proposalInfoColumns}
            data={proposalInfoData}
            enablePagination={false}
            getRowId={(row) => row.proposal_id}
          />
          <Typography variant="h6" mt={4} mb={2}>
            Advertising Location Details
          </Typography>
          {/* <CommonTable
                        columns={locationColumns}
                        data={proposalData.locations || []}
                        enablePagination={false}
                        getRowId={(row, index) => row.center_name + index}
                    />
                    <Typography variant="h6" mt={4} mb={2}>Shortlisted Suppliers</Typography> */}
          <CommonTable
            columns={shortlistedColumns}
            data={shortlistedSuppliers || []}
            enablePagination={false}
            getRowId={(row, index) => row.center_name + row.pincode + index}
          />
          <Button variant="contained" onClick={handleViewMap} sx={{ mt: 3 }}>
            View Map
          </Button>
        </>
      ) : (
        <Typography>Loading proposal data...</Typography>
      )}
    </Box>
  );
};

export default ProposalSummary;
